webpackJsonp([69872653571698],{

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _MarkdownPage = __webpack_require__(46);
	
	var _MarkdownPage2 = _interopRequireDefault(_MarkdownPage);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createLink = __webpack_require__(35);
	
	var _sectionList = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tutorial = function Tutorial(_ref) {
	  var data = _ref.data,
	      location = _ref.location;
	
	  // HACK The injected location prop doesn't update when hash changes
	  // This might be a gatsby issue, or a react-router/history issue,
	  // Or we might be using either library incorrectly.
	  // For now this patch keeps the hash in sync by JIT copying it from window.
	  // The undefined check prevents us from breaking on production build.
	  if (typeof window !== 'undefined' && typeof window.location !== 'undefined') {
	    location.hash = window.location.hash;
	  }
	
	  return Glamor.createElement(_MarkdownPage2.default, {
	    enableScrollSync: true,
	    createLink: _createLink.createLinkTutorial,
	    location: location,
	    markdownRemark: data.markdownRemark,
	    sectionList: _sectionList.sectionListTutorial,
	    titlePostfix: ' - React'
	  });
	}; /**
	    * Copyright (c) 2013-present, Facebook, Inc.
	    *
	    * @emails react-core
	    */
	
	Tutorial.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	// eslint-disable-next-line no-undef
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = Tutorial;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-tutorial-js-54c700c05b596ea0a890.js